/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Still_Hen_SinkInputs */

const en_tall_still_hen_sink = /** @type {(inputs: Tall_Still_Hen_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surveys disabled`)
};

const de_tall_still_hen_sink = /** @type {(inputs: Tall_Still_Hen_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befragungen deaktiviert`)
};

/**
* | output |
* | --- |
* | "Surveys disabled" |
*
* @param {Tall_Still_Hen_SinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_still_hen_sink = /** @type {((inputs?: Tall_Still_Hen_SinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Still_Hen_SinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_still_hen_sink(inputs)
	return de_tall_still_hen_sink(inputs)
});